<div class="tabs__flex-center">
  <h3>{{ title() }}</h3>
</div>
<div class="tabs__table">
  @for (row of rows(); track $index) {
    <div class="tabs__table-row">
      <div class="tabs__table-col">{{ row.title }}</div>
      @if (auth.isSelfServiceEnabled && row.display === "bgp-component") {
        <div class="tabs__table-col">
          @if (isInfrastructureDelegate() && !firewallEnabled()) {
            <span
              class="table-properties__flex"
              [class.table-properties__flex--blue]="row.objectValue.bfd === true"
              [class.table-properties__flex--disabled]="false"
            >
              {{ row.objectValue.bfd | enabled_or_value }}
              <selfservice-toggle
                [active]="row.objectValue.bfd === true"
                [tooltipText]="'Selfservice.Tooltip.BFD' | translate"
                (click)="onBfdSelfService()"
              ></selfservice-toggle>
            </span>
          } @else {
            {{ row.objectValue.bfd | enabled_or_value }}
          }
        </div>
      } @else if (row.display === "textbox" && row.arrayValue) {
        <div class="tabs__table-col">
          <div class="tabs__overflow-box">
            @for (value of row.arrayValue; track $index) {
              <div class="tabs__overflow-box-item">{{ value }}</div>
            }
          </div>
        </div>
      } @else if (row.display || row.display === "default") {
        <div class="tabs__table-col">
          {{ row.scalarValue | enabled_or_value }}
        </div>
      }
    </div>
  }
</div>
